import http from "@/apps/shared/baseService/config";

const base = {
  rota: "veiculos",
  nome: "Veículos"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data)
};

const module = {
  actions: {
    listar_veiculos: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .listar(getters.get_veiculos_filtros)
        .then(res => {
          dispatch("disableLoading");
          localStorage.setItem("veiculos", JSON.stringify(res.data));
          commit("set_veiculos", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_veiculo: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar(getters.get_veiculo)
        .then(res => {
          dispatch("disableLoading");
          localStorage.removeItem("veiculos");
          commit("set_veiculo", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização concluída!",
            timeout: 6000
          });
          dispatch("listar_veiculos");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_veiculo: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar(getters.get_veiculo)
        .then(res => {
          dispatch("disableLoading");
          localStorage.removeItem("veiculos");
          commit("set_veiculo", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Veículo cadastrado!",
            timeout: 6000
          });
          dispatch("listar_veiculos");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_veiculo: ({ dispatch }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          localStorage.removeItem("veiculos");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Veículo removido!",
            timeout: 6000
          });
          dispatch("listar_veiculos");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    }
  },
  state: {
    veiculo: {},
    veiculos: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    veiculos_filtros: {
      limitPerPage: 2000,
      page: 1
    }
  },
  mutations: {
    set_veiculo: (state, payload) => (state.veiculo = payload),
    set_veiculos: (state, payload) => (state.veiculos = payload),
    set_veiculos_filtros: (state, payload) => (state.veiculos_filtros = payload)
  },
  getters: {
    get_veiculo: state => state.veiculo,
    get_veiculos: state => state.veiculos,
    get_veiculos_filtros: state => state.veiculos_filtros
  }
};

const routes = [
  {
    path: `/${base.rota}`,
    component: () => import("./views/Main.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
